/**
 * Flag de sessão: cadastro / checkout acabou e o gate de onboarding deve abrir
 * sem passar pelo dashboard.
 */
export const PENDING_ONBOARDING_KEY = 'adlitics_pending_onboarding';

export function markPendingOnboarding(): void {
  sessionStorage.setItem(PENDING_ONBOARDING_KEY, '1');
}

export function hasPendingOnboarding(): boolean {
  return sessionStorage.getItem(PENDING_ONBOARDING_KEY) === '1';
}

export function clearPendingOnboarding(): void {
  sessionStorage.removeItem(PENDING_ONBOARDING_KEY);
}
